export default __webpack_public_path__ + "static/media/inter-room-anim.862bcbe4.gif";